import type { PackageFormParams } from '@openx/types/package';

export const determineFormType = (state?: PackageFormParams): string => {
  if (state?.deal) {
    return 'deal';
  }

  if (state?.brandFloor) {
    return 'brandFloor';
  }

  return '';
};

export const getNewPath = (state: PackageFormParams, type: string): string => {
  const path = type === 'deal' ? '/deals' : '/pricing/floors';
  const uidKey = type === 'deal' ? 'deal' : 'brandFloor';

  return state?.[uidKey]?.uid ? `${path}/${state[uidKey]?.uid}/edit` : `${path}/create`;
};
